import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex align-items-center mx-3" }
const _hoisted_2 = { class: "mr-5" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "flex-grow-1" }
const _hoisted_5 = { class: "card-header pb-2 mt-3" }
const _hoisted_6 = { class: "card-title" }
const _hoisted_7 = { class: "p-card-body" }
const _hoisted_8 = { class: "p-fluid" }
const _hoisted_9 = { class: "p-fluid" }
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("code", { class: "mr-2 text-sm text-indigo-300" }, "{direct_link_id}"),
  /*#__PURE__*/_createElementVNode("code", { class: "mr-2 text-sm text-indigo-300" }, "{subid}"),
  /*#__PURE__*/_createElementVNode("code", { class: "mr-2 text-sm text-indigo-300" }, "{reason}")
], -1)
const _hoisted_12 = { class: "p-fluid" }
const _hoisted_13 = { class: "p-fluid" }
const _hoisted_14 = { class: "mb-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("code", { class: "mr-2 text-sm text-indigo-300" }, "{direct_link_id}"),
  /*#__PURE__*/_createElementVNode("code", { class: "mr-2 text-sm text-indigo-300" }, "{subid}"),
  /*#__PURE__*/_createElementVNode("code", { class: "mr-2 text-sm text-indigo-300" }, "{reason}")
], -1)
const _hoisted_16 = { class: "mb-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Rules ☝️")
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, "Multi-accounts are prohibited.", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", null, "Payments are made twice a month without hold.", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", null, "Money earned from the 1st to the 15th of each month is paid out between the 16th and 18th.", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", null, "Money earned from the 16th to the 31st is paid out between the 1st and 3rd at the beginning of the new month.", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", null, "There may be a delay of several days in case of additional traffic checks.", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", null, "A personal manager and direct contact are available with a daily turnover of $100 or more and quality traffic.", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Features ☝️")
], -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", null, "During the first 1-3 days, CPM may be 2-5 times lower than usual as the anti-fraud system checks the traffic. After verification, you will get access to better advertisers, and bids will increase.", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", null, "A direct link may be banned if 99% of the traffic and sub-IDs are rejected by the anti-fraud system.", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", null, "We recommend using sub-IDs when sending traffic (from 10 to 1000), as this will help the system better optimize your traffic.", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", null, "You have reached the maximum number of Direct Links", -1)
const _hoisted_29 = { class: "p-fluid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimeVueButton = _resolveComponent("PrimeVueButton")!
  const _component_Header = _resolveComponent("Header")!
  const _component_PrimeVueSkeleton = _resolveComponent("PrimeVueSkeleton")!
  const _component_PrimeVueTag = _resolveComponent("PrimeVueTag")!
  const _component_FieldText = _resolveComponent("FieldText")!
  const _component_FieldTextarea = _resolveComponent("FieldTextarea")!
  const _component_PrimeVueDialog = _resolveComponent("PrimeVueDialog")!
  const _component_FieldDropdownNext = _resolveComponent("FieldDropdownNext")!
  const _component_PrimeVueMessage = _resolveComponent("PrimeVueMessage")!
  const _component_FieldCheckbox = _resolveComponent("FieldCheckbox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header, {
      class: "mb-3",
      title: _ctx.$t('protocol_direct_link')
    }, {
      "buttons:end": _withCtx(() => [
        _createVNode(_component_PrimeVueButton, {
          class: "p-button-outlined p-button-primary",
          icon: "pi pi-plus",
          small: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.storeDirectLinkDialog = true))
        })
      ]),
      _: 1
    }, 8, ["title"]),
    (_ctx.endpointsLoading || !_ctx.endpointsFetched)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(3, (index) => {
          return _createVNode(_component_PrimeVueSkeleton, {
            class: "mb-3",
            key: index,
            height: "25px"
          })
        }), 64))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.endpoints.data, (endpoint, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "card",
            key: index
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("a", {
                  class: "mr-3",
                  href: `/statistics/publisher/direct?filters=${_ctx.encodeStatisticsFilters({ endpoint_id: [endpoint.id] })}`,
                  target: "_blank"
                }, [
                  _createVNode(_component_PrimeVueButton, {
                    class: "p-button-outlined p-button-primary",
                    icon: "pi pi-chart-bar",
                    small: ""
                  })
                ], 8, _hoisted_3),
                _createVNode(_component_PrimeVueButton, {
                  class: "p-button-outlined p-button-secondary",
                  icon: "pi pi-directions-alt",
                  small: "",
                  onClick: ($event: any) => (_ctx.showStorePassbackUrlDialog(endpoint))
                }, null, 8, ["onClick"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("h6", null, [
                      _createTextVNode("#" + _toDisplayString(endpoint.id) + " " + _toDisplayString(_ctx.TRAFFIC_CATEGORIES_MAP[endpoint.traffic_category].label), 1),
                      (endpoint.status === _ctx.ENDPOINT_STATUS_DISABLED)
                        ? (_openBlock(), _createBlock(_component_PrimeVueTag, {
                            key: 0,
                            class: "ml-3",
                            value: "Disabled",
                            severity: "danger"
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_FieldText, {
                      "model-value": _ctx.getDirectLinkUrl(endpoint),
                      disabled: ""
                    }, null, 8, ["model-value"])
                  ])
                ])
              ])
            ])
          ]))
        }), 128)),
    _createVNode(_component_PrimeVueDialog, {
      visible: _ctx.storePassbackUrlDialog,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.storePassbackUrlDialog) = $event)),
      header: "Trafficback",
      modal: "",
      dismissableMask: "",
      draggable: false,
      style: { width: '35vw' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_FieldTextarea, {
            modelValue: _ctx.storePassbackUrlForm.passback_url,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.storePassbackUrlForm.passback_url) = $event)),
            modelModifiers: { trim: true },
            name: "passback_url",
            label: "Trafficback URL",
            rows: 2
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_10, [
            _createTextVNode(_toDisplayString(_ctx.$t('available_macros')) + ":", 1),
            _hoisted_11
          ])
        ]),
        _createVNode(_component_PrimeVueButton, {
          label: _ctx.$t('save'),
          icon: "pi pi-save",
          loading: _ctx.storePassbackUrlLoading,
          onClick: _ctx.storePassbackUrl
        }, null, 8, ["label", "loading", "onClick"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_PrimeVueDialog, {
      visible: _ctx.storeDirectLinkDialog,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.storeDirectLinkDialog) = $event)),
      header: _ctx.$t('protocol_direct_link'),
      modal: "",
      dismissableMask: "",
      draggable: false,
      style: { width: '35vw' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_FieldDropdownNext, {
            modelValue: _ctx.storeDirectLinkForm.traffic_category,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.storeDirectLinkForm.traffic_category) = $event)),
            modelModifiers: { number: true },
            name: "traffic_category",
            "errors-map": _ctx.storeDirectLinkFormErrorsMap,
            label: _ctx.$t('category'),
            options: _ctx.TRAFFIC_CATEGORIES
          }, null, 8, ["modelValue", "errors-map", "label", "options"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_FieldTextarea, {
            modelValue: _ctx.storeDirectLinkForm.passback_url,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.storeDirectLinkForm.passback_url) = $event)),
            modelModifiers: { trim: true },
            name: "passback_url",
            "errors-map": _ctx.storeDirectLinkFormErrorsMap,
            label: "Trafficback URL",
            rows: 2
          }, null, 8, ["modelValue", "errors-map"]),
          _createElementVNode("div", _hoisted_14, [
            _createTextVNode(_toDisplayString(_ctx.$t('available_macros')) + ":", 1),
            _hoisted_15
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _hoisted_18,
          _hoisted_19,
          _hoisted_20,
          _hoisted_21,
          _hoisted_22,
          _hoisted_23,
          _hoisted_24,
          _hoisted_25,
          _createElementVNode("p", null, "A maximum of " + _toDisplayString(_ctx.MAX_DIRECT_LINKS) + " direct links are available.", 1),
          _hoisted_26,
          _hoisted_27
        ]),
        (_ctx.endpoints.data.length >= _ctx.MAX_DIRECT_LINKS)
          ? (_openBlock(), _createBlock(_component_PrimeVueMessage, {
              key: 0,
              class: "mb-0",
              severity: "error",
              closable: false
            }, {
              default: _withCtx(() => [
                _hoisted_28
              ]),
              _: 1
            }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_29, [
                _createVNode(_component_FieldCheckbox, {
                  modelValue: _ctx.storeDirectLinkFormAgreement,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.storeDirectLinkFormAgreement) = $event)),
                  label: "I have read and agree to Direct Link's terms of use"
                }, null, 8, ["modelValue"])
              ]),
              _createVNode(_component_PrimeVueButton, {
                label: _ctx.$t('save'),
                icon: "pi pi-save",
                loading: _ctx.storeDirectLinkLoading,
                disabled: !_ctx.storeDirectLinkFormAgreement,
                onClick: _ctx.storeDirectLink
              }, null, 8, ["label", "loading", "disabled", "onClick"])
            ], 64))
      ]),
      _: 1
    }, 8, ["visible", "header"])
  ], 64))
}